import React from "react";
import { Slice } from "gatsby";

type ModuleLoaderProps = {
    previewMode?: boolean;
    rerender?: boolean;
    modules: any[];
    language: string;
    defaultLanguage: string;
    destinationId: string;
    suppliers?: any[];
    oldSuppliers?: any[];
    entries?: any[];
    packageData?: any;
    location?: Location;
    mobileModuleSpacer?: boolean;
}



class ModuleLoader extends React.Component<ModuleLoaderProps> {
    render() {
        return <>
            <Slice alias="entrymodule-0"></Slice>
            <Slice alias="entrymodule-1"></Slice>
            <Slice alias="entrymodule-2"></Slice>
            <Slice alias="entrymodule-3"></Slice>
            <Slice alias="entrymodule-4"></Slice>
            <Slice alias="entrymodule-5"></Slice>
            <Slice alias="entrymodule-6"></Slice>
            <Slice alias="entrymodule-7"></Slice>
            <Slice alias="entrymodule-8"></Slice>
            <Slice alias="entrymodule-9"></Slice>
            <Slice alias="entrymodule-10"></Slice>
            <Slice alias="entrymodule-11"></Slice>
            <Slice alias="entrymodule-12"></Slice>
            <Slice alias="entrymodule-13"></Slice>
            <Slice alias="entrymodule-14"></Slice>
            <Slice alias="entrymodule-15"></Slice>
            <Slice alias="entrymodule-16"></Slice>
            <Slice alias="entrymodule-17"></Slice>
            <Slice alias="entrymodule-18"></Slice>
            <Slice alias="entrymodule-19"></Slice>
            <Slice alias="entrymodule-20"></Slice>
            <Slice alias="entrymodule-21"></Slice>
            <Slice alias="entrymodule-22"></Slice>
            <Slice alias="entrymodule-23"></Slice>
            <Slice alias="entrymodule-24"></Slice>
            <Slice alias="entrymodule-25"></Slice>
            <Slice alias="entrymodule-26"></Slice>
            <Slice alias="entrymodule-27"></Slice>
            <Slice alias="entrymodule-28"></Slice>
            <Slice alias="entrymodule-29"></Slice>
            <Slice alias="entrymodule-30"></Slice>
            <Slice alias="entrymodule-31"></Slice>
            <Slice alias="entrymodule-32"></Slice>
            <Slice alias="entrymodule-33"></Slice>
            <Slice alias="entrymodule-34"></Slice>
            <Slice alias="entrymodule-35"></Slice>
            <Slice alias="entrymodule-36"></Slice>
            <Slice alias="entrymodule-37"></Slice>
            <Slice alias="entrymodule-38"></Slice>
            <Slice alias="entrymodule-39"></Slice>
            <Slice alias="entrymodule-40"></Slice>
            <Slice alias="entrymodule-41"></Slice>
            <Slice alias="entrymodule-42"></Slice>
            <Slice alias="entrymodule-43"></Slice>
            <Slice alias="entrymodule-44"></Slice>
            <Slice alias="entrymodule-45"></Slice>
            <Slice alias="entrymodule-46"></Slice>
            <Slice alias="entrymodule-47"></Slice>
            <Slice alias="entrymodule-48"></Slice>
            <Slice alias="entrymodule-49"></Slice>
            <Slice alias="entrymodule-50"></Slice>
            <Slice alias="entrymodule-51"></Slice>
            <Slice alias="entrymodule-52"></Slice>
            <Slice alias="entrymodule-53"></Slice>
            <Slice alias="entrymodule-54"></Slice>
            <Slice alias="entrymodule-55"></Slice>
            <Slice alias="entrymodule-56"></Slice>
            <Slice alias="entrymodule-57"></Slice>
            <Slice alias="entrymodule-58"></Slice>
            <Slice alias="entrymodule-59"></Slice>
            <Slice alias="entrymodule-60"></Slice>
            <Slice alias="entrymodule-61"></Slice>
            <Slice alias="entrymodule-62"></Slice>
            <Slice alias="entrymodule-63"></Slice>
            <Slice alias="entrymodule-64"></Slice>
            <Slice alias="entrymodule-65"></Slice>
            <Slice alias="entrymodule-66"></Slice>
            <Slice alias="entrymodule-67"></Slice>
            <Slice alias="entrymodule-68"></Slice>
            <Slice alias="entrymodule-69"></Slice>
            <Slice alias="entrymodule-70"></Slice>
            <Slice alias="entrymodule-71"></Slice>
            <Slice alias="entrymodule-72"></Slice>
            <Slice alias="entrymodule-73"></Slice>
            <Slice alias="entrymodule-74"></Slice>
            <Slice alias="entrymodule-75"></Slice>
            <Slice alias="entrymodule-76"></Slice>
            <Slice alias="entrymodule-77"></Slice>
            <Slice alias="entrymodule-78"></Slice>
            <Slice alias="entrymodule-79"></Slice>
            <Slice alias="entrymodule-80"></Slice>
            <Slice alias="entrymodule-81"></Slice>
            <Slice alias="entrymodule-82"></Slice>
            <Slice alias="entrymodule-83"></Slice>
            <Slice alias="entrymodule-84"></Slice>
            <Slice alias="entrymodule-85"></Slice>
            <Slice alias="entrymodule-86"></Slice>
            <Slice alias="entrymodule-87"></Slice>
            <Slice alias="entrymodule-88"></Slice>
            <Slice alias="entrymodule-89"></Slice>
            <Slice alias="entrymodule-90"></Slice>
            <Slice alias="entrymodule-91"></Slice>
            <Slice alias="entrymodule-92"></Slice>
            <Slice alias="entrymodule-93"></Slice>
            <Slice alias="entrymodule-94"></Slice>
            <Slice alias="entrymodule-95"></Slice>
            <Slice alias="entrymodule-96"></Slice>
            <Slice alias="entrymodule-97"></Slice>
            <Slice alias="entrymodule-98"></Slice>
            <Slice alias="entrymodule-99"></Slice>
        </>;
    }
}


export default ModuleLoader;
